export const LOADING_EMPLOYEES_TIMES = 'LOADING_EMPLOYEES_TIMES'
export const GET_EMPLOYEES_TIMES = 'GET_EMPLOYEES_TIMES'